/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import "./bootstrap";

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import "./components";
import "./Components/ThumbsUpDownButton";
import "./Components/FixedThumbsUpDownButton";
import "./Components/InstallPWA";
import "./Components/ShareButtons";
import "./Components/ChromeExtension";
import "./Components/OuibounceModal";

import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://cb71a5b7b89b41a7ba95f05a83f21d0e@glitchtip.aves.pw/11",
    tracesSampleRate: 0.01,
});

// Глобальный обработчик ошибок для перехвата ошибок, возникающих во время выполнения
window.onerror = function (message, source, lineno, colno, error) {
    Sentry.captureException(error || new Error(message));
};

// Обработчик необработанных отклоненных промисов
window.addEventListener("unhandledrejection", function (event) {
    Sentry.captureException(event.reason);
});
